import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { ApolloProvider } from '@trello/graphql';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Null } from 'app/src/components/Null';

export const LazyTeamTemplatePicker: FunctionComponent<{
  orgId: string;
  isModernizedBoardPage?: boolean;
}> = ({ orgId, isModernizedBoardPage }) => {
  const TeamTemplatePicker = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "team-template-picker-container" */ './TeamTemplatePickerContainer'
      ),
    { namedImport: 'TeamTemplatePickerContainer' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Team Template Picker',
      }}
      errorHandlerComponent={Null}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={<Null />}>
          <ApolloProvider>
            <TeamTemplatePicker
              orgId={orgId}
              isModernizedBoardPage={isModernizedBoardPage}
            />
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
